module.exports = __webpack_public_path__ + "static/media/org-health-logo.7c379910.svg";